<div class="sk-cms-article-detail">

    <div class="article-banner"
        {{if style.background.styleType != 'default'}}
            {{if style.background.backgroundType == 'color'}}
                style="background-color:{{style.background.color}}"
            {{/if}}
            {{if style.background.backgroundType == 'img'}}
                style="background-image:url('{{style.background.imgUrl}}')"
            {{/if}}
        {{/if}}
    >
    {{if content.linkType != 'none' && !isDesign}}
        <a class="content-link goto-link" target="_blank" href="{{content.link}}">
    {{/if}}
        <img src="{{content.imgUrl? content.imgUrl: '../../assets/images/pc-banner.png'}}"  style="{{style.frame.type == 'default' ? '': 'width:' + style.frame.width +'px;'+'height:' + style.frame.height +'px;'}}" alt="" cms-smarket>
    {{if content.linkType != 'none' && !isDesign}}
        </a>
    {{/if}}
    </div>

</div>